import { render } from "./SuggestionLayoutButtons.vue?vue&type=template&id=1e0783fe"
import script from "./SuggestionLayoutButtons.vue?vue&type=script&lang=js"
export * from "./SuggestionLayoutButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__